<div style="background-image: url('../../../../assets/imagesNew/Proceed2.png') !important;    background-size: cover;    height: 100vh;">
    <span style="color: white; float: right; margin: 4% 7%; position: relative;"> <h6>V {{version}}</h6> </span>
    <p-dialog [(visible)]="displaypopup"
              [draggable]="false"
              [modal]="true"
              positionType="absolute"
              [closable]="false"
              [maximizable]="false"
              [style]="{ width: '50vw' }">
        <p-header>
            <h2 class="mb-0"
                style="
          font-weight: unset !important;
          font-size: larger !important;
          text-align: center !important;
        ">
                {{ title }}
            </h2>
        </p-header>

        <div class="grid pl-4">
            <div class="col-12 pb-4 pl-0 ml-0">
                <b style="color: red">[ You are required to select at least 3 security questions. ]</b>
            </div>

            <form [formGroup]="questionForm" (ngSubmit)="onSubmitForm()">
                <ng-container formArrayName="questionFormArray">
                    <div *ngFor="
              let questionControl of getFormAsArray().controls;
              let i = index
            "
                         class="mb-3">
                        <ng-container [formGroupName]="i">
                            <div class="grid mt-0">
                                <!--<div class="field col-12 md:col-1">

                                        </div>-->
                                <div class="field col-12 md:col-12 mb-0">
                                    <span>
                                        <p-checkbox name="groupname"
                                                    [binary]="true"
                                                    formControlName="isSelected"></p-checkbox>
                                    </span>
                                    <span>
                                        <label style="padding-left: 10px; margin-bottom: 0px !important">
                                            {{ questionControl.get('questionDesciption').value }}
                                        </label>
                                    </span>
                                </div>
                            </div>
                            <div class="grid mt-0"
                                 *ngIf="
                  questionForm
                    .get('questionFormArray')
                    .controls[i].get('isSelected').value
                ">
                                <div class="field p-fluid col-11 md:col-11 mb-1">
                                    <span class="p-float-label">
                                        <input id="float-input1"
                                               type="text"
                                               pInputText
                                               formControlName="answer" />
                                        <label for="float-input1"> Answer here</label>
                                    </span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
                <hr />
                <div class="grid mt-2">
                    <div class="field col-12 md:col-12 mb-0 ml-6"
                         style="text-align: center">
                        <button pButton
                                type="submit"
                                label="Proceed"
                                class="p-button-plain"
                                style="width: 10rem"></button>
                    </div>
                </div>
            </form>
        </div>

        <!--<p-footer style="display: flex; justify-content:center;">
                <div class="col-12 pageTitle" style="text-align: center !important; font-size: small !important; border-radius: unset !important;">
                    <h2 style=" margin-bottom: 0px !important;">test test....</h2>
                </div>
            </p-footer>-->
    </p-dialog>
</div>
